import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Form, Button } from 'react-bootstrap';
import { required } from '../../../../../../_utils/validators';
import { renderField } from '../../../../common/FormsControls.jsx';
import { createPlaylist } from '../../../../../actions/collection';


const NewPlaylistForm = (props) => {
  const { anyTouched, invalid, submitting, handleSubmit } = props;

  const appendButton = (
    <Button variant="primary" type="submit" disabled={ submitting || invalid }
            title={ gettext('Создать новый плейлист') }>
      <i className="icon icon-plus"></i>
    </Button>
  )

  return <Form onSubmit={ handleSubmit } className={ 'form-inline ' + (anyTouched ? ' was-validate' : '') }>
    <Field component={ renderField }
           element="input"
           required='required'
           name='name'
           validate={ [required] }
           placeholder={ gettext('Новый плейлист') }
           withInputGroup={ true }
           inputGroupAppendButton={ appendButton }
    />
  </Form>
}

export default compose(
  connect(null, { onSubmit: createPlaylist }),
  reduxForm({ form: 'playlistForm' })
)(NewPlaylistForm);
